"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64alphabet = void 0;
const AlphabetStringUppercase_1 = require("./AlphabetStringUppercase");
const AlphabetString_1 = require("./AlphabetString");
const NumbersString_1 = require("./NumbersString");
exports.base64alphabet = `${AlphabetStringUppercase_1.alphabetStringUppercase}${AlphabetString_1.alphabetString}${NumbersString_1.numbersString}+/=`;
